import type {SvgIconProps} from '@mui/material';
import {SvgIcon} from '@mui/material';
import {memo} from 'react';

export const Experiment = memo((props: SvgIconProps) => {
  return (
    <SvgIcon
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      style={{
        width: 'var(--size, 24px)',
        height: 'var(--size, 24px)',
        ...(props.style ?? {}),
      }}
    >
      <path d="M8.82812 14.366C8.61375 14.7098 8.5 15.1029 8.5 15.5068C8.28125 15.582 8.045 15.625 7.8 15.625C6.64062 15.625 5.7 14.7012 5.7 13.5625V7.375C5.31281 7.375 5 7.06777 5 6.6875C5 6.30723 5.31281 6 5.7 6H7.1H8.5H9.9C10.2872 6 10.6 6.30723 10.6 6.6875C10.6 7.06777 10.2872 7.375 9.9 7.375V12.658L8.82812 14.3682V14.366ZM7.1 7.375V9.4375H8.5V7.375H7.1ZM12.7 6H15.5H16.2C16.5872 6 16.9 6.30723 16.9 6.6875C16.9 7.06777 16.5872 7.375 16.2 7.375V10.617L18.7747 14.727C18.9213 14.9611 19 15.2318 19 15.509C19 16.3318 18.3197 17 17.4819 17H10.7181C9.88031 17 9.2 16.3318 9.2 15.509C9.2 15.234 9.27875 14.9633 9.42531 14.727L12 10.617V7.375C11.6128 7.375 11.3 7.06777 11.3 6.6875C11.3 6.30723 11.6128 6 12 6H12.7ZM13.4 7.375V10.8125C13.4 10.9393 13.365 11.0639 13.2972 11.1734L12.2297 12.875H15.9703L14.9028 11.1734C14.835 11.066 14.8 10.9414 14.8 10.8125V7.375H13.4Z" />
    </SvgIcon>
  );
});

Experiment.displayName = 'Experiment';
